import React, { Component } from "react";
import { Link } from "react-router-dom";
import { trans } from "../../helpers/index";
import config from "../../baseConfig/index";
import LanguageList from "../Fragments/LanguageList";
import AuthRightSidebar from "../Fragments/AuthRightSidebar";
import Tab from "../Fragments/Tab";
import PrivateClients from "./Forms/PrivateClients";
import B2bLogin from "./Forms/B2bLogin";
import B2bChangePassword from "./Forms/B2bChangePassword";
import { localStorageGetItem } from "../../storage";

class LoginView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      b2bForm: 1,
      b2bEmail: "",
      b2bJwt: "",
      currentTab: 0,
      isCurator: false,
      languageChanged: false,
    };

    // Bind own methods
    this.updateParentState = this.updateParentState.bind(this);
    this.updateAccount = this.updateAccount.bind(this);
  }

  updateParentState(newState) {
    this.setState(newState);
  }

  componentDidMount() {
    const hash = window.location.hash.replace("#", "");

    if (hash === "b2b") {
      window.history.pushState("", document.title, window.location.pathname);
    }
  }

  businessContent() {
    if (this.state.b2bForm === 1) {
      return (
        <B2bLogin
          trans={this.props.trans}
          csrf_token={this.props.csrf_token}
          setTokenAction={this.props.setTokenAction}
          updateParentState={this.updateParentState}
          b2bEmail={this.state.b2bEmail}
          isCurator={this.state.isCurator}
          selectedTypeIndex={this.props.selectedTypeIndex}
          languageChanged={this.state.languageChanged}
        />
      );
    } else if (this.state.b2bForm === 2) {
      return (
        <B2bChangePassword
          trans={this.props.trans}
          csrf_token={this.props.csrf_token}
          setTokenAction={this.props.setTokenAction}
          b2bEmail={this.state.b2bEmail}
          b2bJwt={this.state.b2bJwt}
          isCurator={this.state.isCurator}
        />
      );
    }
  }

  updateAccount() {
    this.setState({
      languageChanged: true,
    });
  }

  render() {
    return (
      <div
        className={`main-wrapper ${localStorageGetItem("defaultLngPrefix")}`}
      >
        <aside className="main-wrapper__left scroller-block">
          <div className="main-wrapper__left-inner">
            <Link
              className="main-wrapper__logo sprite db"
              to={config.urlPrefix}
            >
              {trans("logo.title")}
            </Link>

            <Tab
              items={[
                {
                  title: trans(this.props.trans, "auth.login.tab.title1"),
                  content: (
                    <PrivateClients
                      trans={this.props.trans}
                      csrf_token={this.props.csrf_token}
                      loginEmail={this.props.loginEmail}
                      setTokenAction={this.props.setTokenAction}
                    />
                  ),
                  clickCallback: () => this.props.setCurrentTabAction(0),
                },
                {
                  title: trans(this.props.trans, "auth.login.tab.title2"),
                  content: this.businessContent(),
                  clickCallback: () => this.props.setCurrentTabAction(1),
                },
              ]}
              index={
                window.location.hash.replace("#", "") === "b2b"
                  ? 1
                  : this.props.tabIndex
              }
            />
            
          </div>

          <LanguageList
            setTranslationsAction={this.props.setTranslationsAction}
            updateAccount={this.updateAccount}
          />
        </aside>

        <AuthRightSidebar trans={this.props.trans} />
      </div>
    );
  }
}

export default LoginView;
